import { Controller } from "react-hook-form";
import FormInput from "~/components/form-inputs/form-input";
import { SelectDropDown } from "~/components/ui";

const DetailsStep = ({ control, errors, register }: any) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <FormInput
          label="Title"
          placeholder="Enter PTW title"
          name="title"
          register={register}
          errors={
            errors?.title?.message
              ? { error: true, message: errors.title.message as string }
              : undefined
          }
        />
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-neutral-600">
            Permit Type
          </label>
          <Controller
            control={control}
            name="permitType"
            render={({ field: { onChange, value } }) => (
              <SelectDropDown
                placeholder="Select type"
                options={[
                  { label: "Hot Work", value: "Hot Work" },
                  { label: "Cold Work", value: "Cold Work" },
                  { label: "Confined Space", value: "Confined Space" },
                  { label: "Working at Heights", value: "Working at Heights" },
                ]}
                value={{ label: value, value }}
                onChange={(val: any) => onChange(val?.value)}
              />
            )}
          />
          {errors?.permitType?.message && (
            <p className="text-xs text-red-500">
              {errors.permitType.message as string}
            </p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <FormInput
          label="Location"
          placeholder="Enter location"
          name="location"
          register={register}
          errors={
            errors?.location?.message
              ? { error: true, message: errors.location.message as string }
              : undefined
          }
        />
        <div className="space-y-1.5">
          <label className="text-sm font-medium text-neutral-600">
            JSA Reference
          </label>
          <Controller
            control={control}
            name="jsaId"
            render={({ field: { onChange } }) => (
              <SelectDropDown
                placeholder="Select JSA"
                options={[]}
                value={null}
                onChange={(val: any) => onChange(val?.value)}
              />
            )}
          />
          {errors?.jsaId?.message && (
            <p className="text-xs text-red-500">
              {errors.jsaId.message as string}
            </p>
          )}
        </div>
      </div>
      <FormInput
        label="Description"
        placeholder="Enter description"
        name="description"
        register={register}
        errors={
          errors?.description?.message
            ? { error: true, message: errors.description.message as string }
            : undefined
        }
      />
    </div>
  );
};

export default DetailsStep;
